<template>
  <div @click="activeInput()" class="ac-input">
    <label :class="{ disabled: disabled }" for="">
      <span :class="{ 'active-span': isActive || value }"> {{ label }} </span>
      <input
        v-model="temp"
        ref="input"
        type="text"
        :maxLength="maxLength"
        :dir="ltr ? 'ltr' : 'rtl'"
        :disabled="disabled"
        @focus="isActive = true"
        @input="inputHandler()"
        @blur="isActive = false"
      />
      <slot name="append" />
    </label>
  </div>
</template>

<script>
export default {
  name: "AccountFeild",
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: 200,
    },
    ltr: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
      temp: this.value,
    };
  },
  methods: {
    activeInput() {
      if (!this.disabled) {
        this.isActive = true;
        this.$refs.input.focus();
      }
    },
    inputHandler() {
      if (this.type == "persian") {
        this.temp = this.$S2Fa(this.temp);
      } else if (this.type == "number") {
        this.temp = this.$numberFilter(this.temp, this.maxLength);
      } else if (this.type == "dash") {
        if (this.temp) {
          this.temp = this.$separator(this.temp);
          let lngth = this.temp.replace(/-/gi, "").length;
          if (lngth >= 16) {
            this.temp = this.temp.replace(/-/gi, "").slice(0, 16);
            this.temp = this.$separator(this.temp);
          }
        }
      }
      this.$emit("input", this.temp);
    },
  },
  watch: {
    value(val) {
      this.temp = val;
    },
  },
  mounted() {
    console.log(this.value);
  },
};
</script>

<style lang="scss" scoped>
.ac-input {
  border-radius: 4px;
  // overflow: hidden;

  .bd {
    input {
      width: 100%;
    }
  }
  display: flex;
  flex-direction: column;
  row-gap: 3px;
  width: 100%;
  .active-span {
    color: var(--primary-color);
    transform: translateY(-25px);
  }
  label {
    display: flex;
    flex-direction: row;
    background: var(--light-grey);
    padding: 8px 12px;
    border-radius: 4px;
    position: relative;
    &.disabled {
      background-color: var(--loading-back) !important;
    }
    input {
      background: transparent;
      width: 100%;
      z-index: 2;
    }
    span {
      transform: translateY(0px);
      font-weight: 400;
      font-size: clamp(12px, 2vw, 14px);
      transition: 500ms;
      position: absolute;
    }
  }
}
</style>
>
